<template>
  <div>
    <b-table
      :stacked="stacked"
      :hover="hover"
      :striped="striped"
      :bordered="bordered"
      :small="small"
      :fixed="fixed"
      :items="items"
      :fields="captions"
      :current-page="1"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      :per-page="perPage"
      @sort-changed="sortingChanged"
      :no-sort-reset="true"
      :no-local-sorting="true">
      <template slot="actions" slot-scope="data">
        <b-form-checkbox
          :key="data.item.code"
          :checked="isItemChecked(data.item.code)"
          @change="selectItem($event, data.item)"
        ></b-form-checkbox>
      </template>
    </b-table>
    <div class="row">
      <div class="col-sm-4">
        <b-pagination :total-rows="rowCount" :per-page="perPage" v-model="currentPage" prev-text="Prec"
                      next-text="Succ"
                      @input="fetchData(currentPage)"/>
      </div>
    </div>
  </div>
</template>

<script>
  import IdTypeService from '../../services/IdTypeService'
  import miniToastr from 'mini-toastr' //ES6
  import i18n from '../../config/i18n'

  const idTypeService = IdTypeService.build();

  export default {
    name: "IdTypeSelectList",
    props: {
      value: {
        type: Object,
        default: () => {}
      },
      stacked: {
        type: String,
        default: 'sm'
      },
      hover: {
        type: Boolean,
        default: true
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      },
      perPage: {
        type: Number,
        default: 7
      },
      fields: {
        type: Array,
        default: () =>
          [
            {
              key: 'code',
              sortable: true,
              label: i18n.t('page.generic.code')
            },
            {
              key: 'description',
              sortable: true,
              label: i18n.t('page.generic.description')
            },
            {
              key: 'actions',
              sortable: false,
              label: ''
            }
          ]
      },

    },
    data() {
      return {
        currentPage: 1,
        tableData: [],
        tableTotalRows: 0,
        sortBy: 'code',
        sortDesc: false,
        sortDirection: 'asc',
      }
    },
    created() {
      miniToastr.init();
      miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
      this.fetchData(1)
    },
    computed: {
      items: function () {
        const items = this.tableData;
        return Array.isArray(items) ? items : []
      },
      captions: function () {
        return this.fields
      },
      rowCount: function () {
        return this.tableTotalRows
      }
    },
    methods: {
      async fetchData(currentPage) {
        try {
          let response = await idTypeService.search({
            max: this.perPage,
            offset: (currentPage - 1) * this.perPage,
            sort: this.sortBy,
            order: (this.sortDesc ? 'desc' : 'asc')
          });
          this.tableData = response.data;
          this.tableTotalRows = response.total
        } catch (exception) {
          miniToastr.error(exception.message)
        }
      },
      sortingChanged(ctx) {
        this.sortBy = ctx.sortBy;
        this.sortDesc = ctx.sortDesc;
        this.fetchData(this.currentPage)
      },
      selectItem(event, element) {
        if(event === true) {
          this.value = element
        } else {
          this.value = {}
        }
        this.$emit('input', this.value);

      },
      isItemChecked(itemCode) {
        return this.value && this.value.code === itemCode
      },
      save() {
        this.$emit('addItems', this.value);
        this.clearData();
      }
    }
  }
</script>

<style scoped>

</style>
